<template>
  <v-form
    id="updateProfileForm"
    ref="updateProfileForm"
  >
    <v-card-text style="max-height: 320px; overflow-y: scroll; overflow-x: hidden; flex-grow: 1">
      <PolteqTextField
        v-model="userInfo['email']"
        field-id="emailField"
        :label="i18n.t('fields.emailaddress')"
        :rules="[rules.email]"
        type="email"
        autocomplete="username"
        icon="mdi-email-outline"
        :readonly="true"
      />
      <PolteqTextField
        v-model="userInfo['phoneNumber']"
        field-id="phoneNumberField"
        :label="i18n.t('fields.phonenumber')"
        :rules="[rules.phone_number]"
        type="tel"
        icon="mdi-phone-outline"
        :readonly="!edit"
      />

      <v-card-text v-if="edit">
        <v-row>
          <PolteqTextField
            v-model="userInfo['givenName']"
            field-id="firstNameField"
            :label="i18n.t('fields.firstName')"
            :rules="[rules.required]"
            type="text"
            icon="mdi-account-outline"
            :readonly="!edit"
          />
          <PolteqTextField
            v-model="userInfo['familyName']"
            field-id="lastNameField"
            :label="i18n.t('fields.lastName')"
            :rules="[rules.required]"
            type="text"
            :readonly="!edit"
            style="margin-left: 4px"
          />
        </v-row>
      </v-card-text>
      <template v-if="userInfo['address'].street !== '' || edit">
        <template v-if="!edit">
          <v-textarea
            class="ma-10 pa-10"
            rows="3"
            prepend-icon="mdi-home-city-outline"
            :label="i18n.t('fields.address')"
            variant="solo"
            density="comfortable"
            no-resize
            readonly
            flat
            :model-value="
              userInfo['address'].street +
                ' ' +
                userInfo['address'].houseNumber +
                ' ' +
                userInfo['address'].houseNumberAddition +
                '\n' +
                userInfo['address'].postCode +
                ' ' +
                userInfo['address'].city +
                '\n' +
                userInfo['address'].country
            "
          />
        </template>
        <template v-else>
          <PolteqTextField
            v-model="userInfo['address'].street"
            field-id="streetField"
            :label="i18n.t('fields.street')"
            type="text"
            icon="mdi-map-marker-outline"
            :readonly="!edit"
          />

          <v-card-text>
            <v-row>
              <PolteqTextField
                v-model="userInfo['address'].houseNumber"
                field-id="houseNumberField"
                :label="i18n.t('fields.housenumber')"
                type="text"
                icon="mdi-map-marker-outline"
                :readonly="!edit"
              />
              <PolteqTextField
                v-model="userInfo['address'].houseNumberAddition"
                field-id="houseNumberAdditionField"
                :label="i18n.t('fields.housenumberaddition')"
                type="text"
                :readonly="!edit"
                style="margin-left: 4px; border: 1px"
              />
            </v-row>
          </v-card-text>
          <v-card-text>
            <v-row>
              <PolteqTextField
                v-model="userInfo['address'].postCode"
                field-id="postCodeField"
                :label="i18n.t('fields.postCode')"
                type="text"
                icon="mdi-map-marker-outline"
                :readonly="!edit"
              />
              <PolteqTextField
                v-model="userInfo['address'].city"
                field-id="cityField"
                :label="i18n.t('fields.city')"
                type="text"
                :readonly="!edit"
                style="margin-left: 4px"
              />
            </v-row>
          </v-card-text>
          <v-select
            v-model="userInfo['address'].country"
            variant="solo"
            prepend-icon="mdi-map-marker-outline"
            flat
            density="comfortable"
            :label="i18n.t('fields.country')"
            :items="countryNames"
            auto-select-first
            hide-selected
          />
        </template>
      </template>
    </v-card-text>
    <v-card-text
      v-if="!edit"
      style="text-align: end"
    >
      <PolteqButton
        button-id="editProfileButton"
        icon="mdi-account-edit-outline"
        :button-text="i18n.t('texts.editprofile')"
        @click="edit = true"
      />
      <br>
      <PolteqButton
        button-id="changePasswordButton"
        icon="mdi-account-key-outline"
        :button-text="i18n.t('texts.editpassword')"
        @click="NavigationHelper.openForm(router, Forms.CHANGE_PASSWORD)"
      />
    </v-card-text>
    <v-card-text
      v-else
      style="text-align: end"
    >
      <PolteqButton
        button-id="saveProfileButton"
        icon="mdi-account-check-outline"
        :button-text="i18n.t('texts.saveprofile')"
        @click="saveProfile(userInfo)"
      />
      <br>
      <PolteqButton
        button-id="cancelEditButton"
        icon="mdi-account-cancel-outline"
        :button-text="i18n.t('texts.cancel')"
        @click="cancelEdit()"
      />
    </v-card-text>
  </v-form>
</template>

<script lang="ts" src="./PersonalProfile.ts" />
